import { useEffect, useState } from "react";
import ModernModal from "./EditModal";
import PhotosUploader from "./PhotosUploader";

import { motion } from "framer-motion";
import getCsrfToken from "../../../clients/features/get_csrfToken";

import {
  DndContext,
  closestCenter
} from "@dnd-kit/core";

import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

<motion.div
  className="modern-card"
  whileHover={{ y: -5 }}
  transition={{ duration: 0.2 }}
></motion.div>

function SortableItem({ id, photo, onDelete }) {

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <motion.div
      ref={setNodeRef}
      style={style}
      layout
      className="photo-card"
    >
      {/* Drag area */}
      <div
        className="drag-handle"
        {...attributes}
        {...listeners}
      >
        <img src={photo} alt="" />
      </div>

      {/* Delete button */}
      <button
        className="delete-btn"
        onClick={(e) => {
          e.stopPropagation(); // 👈 IMPORTANT
          onDelete(id);
        }}
      >
        ✕
      </button>

    </motion.div>
  );
}

export default function PhotosManager({ data, hotelId }) {


  const [isOpen, setIsOpen] = useState(false);
  const [listPhotos, setListPhotos] = useState([]);

    useEffect(() => {
    if (data?.photos) {
        setListPhotos(data.photos);
    }
    }, [data]);
  const handlePhotos = async (photosArray) => {
  try {

    const csrfToken = await getCsrfToken();

    await fetch(
      `https://api.komorotel.com/api/hotels/${hotelId}`,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          photos: photosArray
        })
      }
    );
    

  } catch (err) {
    console.error(err);
  }
}; 
const handleDragEnd = (event) => {
  const { active, over } = event;

  if (active.id !== over?.id) {
    const oldIndex = listPhotos.indexOf(active.id);
    const newIndex = listPhotos.indexOf(over.id);

    const newOrder = arrayMove(listPhotos, oldIndex, newIndex);
    setListPhotos(newOrder);
    handlePhotos(newOrder);
  }
};


  // 🔥 Cloudinary upload
  const uploadToCloudinary = async (file) => {

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "komorotel_unsigned");

    const res = await fetch(
      "https://api.cloudinary.com/v1_1/dhwqnwnvh/image/upload",
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await res.json();
    return result.secure_url;
  };

  // Drag & drop handler
  const handleUpload = async (files) => {

  const uploadedUrls = await Promise.all(
    files.map(file => uploadToCloudinary(file))
  );

  const newPhotos = [...listPhotos, ...uploadedUrls];

  setListPhotos(newPhotos);

  // Envoie direct au serveur
  await handlePhotos(newPhotos);

  setIsOpen(false);
};
const handleDelete = (photoId) => {
  const newPhotos = listPhotos.filter(p => p !== photoId);
  setListPhotos(newPhotos);
  handlePhotos(newPhotos);
};

  return (
    <div className="modern-card">

      <div className="section-title d-flex justify-content-between">
        Photos
        <button className="modern-button" onClick={() => setIsOpen(true)}>
          + Ajouter
        </button>
      </div>

      {/* Galerie */}
      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={listPhotos} strategy={verticalListSortingStrategy}>
            <div className="photo-grid">
            {listPhotos.map((photo) => (
                <SortableItem
                key={photo}
                id={photo}
                photo={photo}
                onDelete={handleDelete}
                />
            ))}
            </div>
        </SortableContext>
    </DndContext>

      {/* Modal */}
      <ModernModal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <h4>Ajouter des photos</h4>
        <PhotosUploader onUpload={handleUpload} />
      </ModernModal>

    </div>
  );
}